/**
 * Per-profile filters for ticket status lists (see perfis_usuarios.ids_status_tickets_*).
 * Superadmin bypasses. NULL / empty stored list = show all.
 */

export function parseIdList(raw) {
    if (raw == null || raw === '') return null;
    if (Array.isArray(raw)) {
        const ids = raw.map((x) => Number(x)).filter((n) => Number.isFinite(n));
        return ids.length ? ids : null;
    }
    if (typeof raw === 'string') {
        const t = raw.trim();
        if (!t || t === 'null') return null;
        try {
            const j = JSON.parse(t);
            if (Array.isArray(j)) {
                const ids = j.map((x) => Number(x)).filter((n) => Number.isFinite(n));
                return ids.length ? ids : null;
            }
        } catch (_) {
            return null;
        }
    }
    return null;
}

export function getSessionUserTicketStatusIds(kind) {
    try {
        const raw = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('user') : null;
        if (!raw) return null;
        const u = JSON.parse(raw);
        if (!u) return null;
        if (Number(u.is_superadmin) === 1 || Number(u.id_perfil_usuario) === 4) return null;
        const key = kind === 'colunas' ? 'ids_status_tickets_colunas' : 'ids_status_tickets_select';
        return parseIdList(u[key]);
    } catch (_) {
        return null;
    }
}

export function filterTicketStatusesByPerfil(statusList, kind) {
    const allowed = getSessionUserTicketStatusIds(kind);
    if (!allowed || !allowed.length) return Array.isArray(statusList) ? statusList : [];
    const set = new Set(allowed);
    return (statusList || []).filter((s) => set.has(Number(s.id_status_ticket)));
}

export function parsePerfilStatusIdsFromRow(row, field) {
    if (!row || row[field] == null || row[field] === '') return [];
    const ids = parseIdList(row[field]);
    return ids && ids.length ? ids : [];
}
